import { render, staticRenderFns } from "./edificio.vue?vue&type=template&id=75bcadc9&scoped=true&"
import script from "./edificio.vue?vue&type=script&lang=js&"
export * from "./edificio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bcadc9",
  null
  
)

export default component.exports